var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgComboBox = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 160,
  height: 108,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 158,
  height: 30,
  x: 1,
  y: 1,
  fill: "var(--hop-neutral-surface)",
  stroke: "var(--hop-neutral-border-strong)",
  strokeWidth: 2,
  rx: 7
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 158,
  height: 70,
  x: 1,
  y: -1,
  fill: "var(--hop-neutral-surface)",
  stroke: "var(--hop-neutral-border-strong)",
  strokeWidth: 2,
  rx: 7,
  transform: "matrix(1 0 0 -1 0 106)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--hop-neutral-icon)",
  fillRule: "evenodd",
  d: "M137.5 14.921a3.421 3.421 0 1 1 6.843 0 3.421 3.421 0 0 1-6.843 0M140.921 10a4.921 4.921 0 1 0 2.91 8.89l2.817 2.818a.75.75 0 0 0 1.061-1.06l-2.818-2.818a4.922 4.922 0 0 0-3.97-7.83",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "var(--hop-neutral-border)",
  strokeLinecap: "round",
  strokeWidth: 4,
  d: "M16 56h118.629M16 88h102M16 72h79M16 16h79"
})));
export default SvgComboBox;